import React, { useState } from 'react';
import { Card, IconButton } from '@mui/material';
import ReactCardFlip from 'react-card-flip';
import Grid from '@mui/material/Grid';
import FlipCameraAndroidIcon from '@mui/icons-material/FlipCameraAndroid';
import FlipCameraAndroidOutlinedIcon from '@mui/icons-material/FlipCameraAndroidOutlined';

/**
 * @param {Object} props
 * @param {string|Object} props.frontDataHeader
 * @param {string|Object} props.frontDataEntry
 * @param {string|Object} props.backDataHeader
 * @param {string|Object} props.backDataEntry
 */
export default function FlipCard(props) {
  const {
    frontDataHeader,
    frontDataEntry,
    backDataHeader,
    backDataEntry,
  } = props;

  const [flipped, setFlipped] = useState(false);

  const handleFlip = () => {
    setFlipped(!flipped);
  };

  return (
    <Card variant="outlined" sx={{ marginBottom: '10px', padding: '10px' }}>
      <ReactCardFlip isFlipped={flipped} infinite containerClassName="data-display-contents data-display-padding">
        <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
          <Grid size={{ xs: 3 }}>
            {frontDataHeader}
          </Grid>
          <Grid size={{ xs: 1 }}>
            <IconButton
              onClick={handleFlip}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                '&:hover': {
                  backgroundColor: 'rowHover',
                  color: 'primary.main',
                  borderColor: 'primary.main',
                },
              }}
            >
              <FlipCameraAndroidIcon />
            </IconButton>
          </Grid>
          {frontDataEntry}
        </Grid>
        <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
          <Grid size={{ xs: 3 }}>
            {backDataHeader}
          </Grid>
          <Grid size={{ xs: 1 }}>
            <IconButton
              onClick={handleFlip}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                '&:hover': {
                  backgroundColor: 'rowHover',
                  color: 'primary.main',
                  borderColor: 'primary.main',
                },
              }}
            >
              <FlipCameraAndroidOutlinedIcon />
            </IconButton>
          </Grid>
          {backDataEntry}
        </Grid>
      </ReactCardFlip>
    </Card>
  );
}
